import React, { useState } from 'react'

import { LoadingFeedback } from 'components'
import { SettingsForm } from './components'
import { Text } from '../'

import useFetch from 'hooks/useFetch'

import * as service from 'service'

const CustomColors = () => {
  const [loading, setLoading] = useState(false)

  const { response, isLoadingStart, refresh } = useFetch(
    service.dponet.privacyPortal.getTheme,
  )

  const portalTheme = response?.data?.privacyPortalTheme

  return (
    <>
      <LoadingFeedback open={loading} />
      <Text color="primary" fontSize="7vh" variant="h1">
        Personalize suas Cores
      </Text>
      {!isLoadingStart && (
        <SettingsForm
          portalTheme={portalTheme}
          refresh={refresh}
          loading={loading}
          setLoading={setLoading}
        />
      )}
    </>
  )
}

export default CustomColors
